import type { FaireProductEntity } from "../../entity_types/product";

export const p_9mjc7rd579: FaireProductEntity = {
  token: "p_9mjc7rd579",
  type: "product",
  name: "Tiny Copper Spheres",
  brandToken: "b_ciwhgi8nfq",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/366c452bb307a011fba64a15147f537ee28caae7c215c4fa3f072246dc1c326b.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/bba693bc09adbe712571a8ee05360cc6cb0c793d6994b26a8001562b9e1e5ec1.jpeg",
    "https://cdn.faire.com/fastly/3efc53fd6ef0b89fc2fec221c13ffbc987030f99da4db20f5d668ba109206697.jpeg",
    "https://cdn.faire.com/fastly/a673c65ec44a4e0b98c26c59590b5d22b0c234c4afbde31b041d61940ee98ef6.jpeg",
  ],
  priceDollars: 2.77,
  description:
    "🟤 Tiny Copper Spheres 🟤\n\nThese tiny copper spheres are smoothly polished into classic round shapes, highlighting copper’s rich, warm luster. Compact and eye-catching, they’re ideal for small displays, crystal grids, or as tactile accent pieces customers can’t resist picking up. Each sphere is about .5 inch.\n\nSimple, elemental, and endlessly versatile.\n\nProduct Details\n• Polished copper spheres\n• Small, compact size\n• Smooth, reflective metallic finish\n• Warm copper tone with natural patina potential\n• Each sphere is consistent in shape with subtle surface variation\n• Ideal for display trays, grids, and add-on purchases\n• Metal material — natural aging and patina may occur over time\n\nCopper is often associated with flow, vitality, and conductivity, giving these tiny spheres a grounded yet energetic presence.\n\nA great addition for shops offering copper spheres, metal minerals, and approachable wholesale accents with classic appeal. 🟤",
  tags: [],
  msrpDollars: 5.54,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:25:05.360Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
